import { render, staticRenderFns } from "./IconAutoPlay.vue?vue&type=template&id=cbaff644&"
import script from "./IconAutoPlay.vue?vue&type=script&lang=ts&"
export * from "./IconAutoPlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports